import {useDispatch} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import ModalHeader from "../../../core/Modal/ModalHeader/ModalHeader";
import CreateForm from "../CreateRoomForm/CreateForm";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import {useTranslation} from "react-i18next";

function CreateGameModalMobile() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    return <>
        <ModalHeader>
            <div className="create-game-modal-header">
                <p>{t('form.create')}</p>
                <i className="icon-close" onClick={()=> dispatch(closeLobbyModal())}/>
            </div>
        </ModalHeader>
        <ModalBody>
            <CreateForm/>
        </ModalBody>
    </>
}

export default CreateGameModalMobile